import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const HSDiplomaIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 681.28 1000"
      role="img"
    >
      <title>{educationLevels().level3.label}</title>
      <path
        d="M799.87,293.65a323.67,323.67,0,0,0,41.22-158.34V123.67a12.42,12.42,0,0,0-12.43-12.42H614.82C612.84,49.81,562.37.4,500.44.4S388.06,49.8,386.07,111.25H172.22a12.42,12.42,0,0,0-12.42,12.42v11.64A323.61,323.61,0,0,0,201,293.65a107.7,107.7,0,0,0-19.58,61.66V900.76a99.76,99.76,0,0,0,99.64,99.64H719.81a99.76,99.76,0,0,0,99.64-99.64V355.3A107.69,107.69,0,0,0,799.87,293.65ZM590.06,110.75H410.83a89.71,89.71,0,0,1,179.23,0Zm-383.76,790V883.13H794.6v17.61a74.89,74.89,0,0,1-74.79,74.8H281.08A74.87,74.87,0,0,1,206.3,900.74Zm9.34-583.27A328.39,328.39,0,0,0,300.24,403v59.58a42.49,42.49,0,1,0,24.84,0v-44A323.56,323.56,0,0,0,485.53,461h29.86a323.76,323.76,0,0,0,163.76-44.34v45.88a42.5,42.5,0,1,0,24.84,0V400.58a328.43,328.43,0,0,0,81.27-83.12,81.43,81.43,0,0,1,9.35,37.83v503H206.3v-503A81.48,81.48,0,0,1,215.64,317.47ZM709.21,503a17.65,17.65,0,1,1-17.65-17.65A17.67,17.67,0,0,1,709.21,503ZM679.14,136.1V387.51a299,299,0,0,1-163.76,48.67H485.51a299,299,0,0,1-160.44-46.54V136.11H679.14ZM330.3,503a17.66,17.66,0,1,1-17.65-17.65A17.67,17.67,0,0,1,330.3,503ZM184.65,136.1H300.24v236C230.14,317.11,184.9,231.82,184.65,136.1Zm631.6,0c-.24,94.21-44,178.34-112.26,233.38V136.1Z"
        transform="translate(-159.8 -0.4)"
      />
      <path
        d="M261,577.67v161.2c0,37.14,25.6,67.38,57.06,67.38H682.85c31.47,0,57.07-30.24,57.07-67.38V577.67a12.42,12.42,0,0,0-12.42-12.42H273.38A12.42,12.42,0,0,0,261,577.67Zm453.35,12.42a98.12,98.12,0,0,1-97.17,85.53H512.87V651.21a12.43,12.43,0,1,0-24.85,0v24.41H383.75a98.12,98.12,0,0,1-97.17-85.53ZM285.8,651.42a122.6,122.6,0,0,0,97.95,49.05H488V730.3a12.43,12.43,0,0,0,24.85,0V700.47H617.14a122.56,122.56,0,0,0,98-49.05v87.45c0,23.45-14.46,42.53-32.23,42.53H318c-17.78,0-32.23-19.08-32.23-42.53V651.42Z"
        transform="translate(-159.8 -0.4)"
      />
      <path
        d="M587.81,233.87a12.41,12.41,0,0,0-11.71-12.76c-1-.07-25.71-2.08-32.94-25.1a12.42,12.42,0,0,0-11.85-8.71H471.07a12.44,12.44,0,0,0-12.23,10.2c-.48,2.41-5.64,24.59-30.77,26.1a12.39,12.39,0,0,0-11.67,12.77c.1,3.48,3.44,86.06,77.91,145.88a12.37,12.37,0,0,0,15.55,0C584.38,322.42,587.71,237.46,587.81,233.87Zm-25.94,9.64c-3.18,21.58-15.19,72.63-59.76,112.76-44.07-39.57-56.31-88.64-59.64-110,20.86-5.67,32.47-21.29,37.76-34.17h42.69C532.48,231.85,549.88,240.09,561.87,243.51Z"
        transform="translate(-159.8 -0.4)"
      />
    </svg>
  );
};

export default HSDiplomaIcon;

HSDiplomaIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
